import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import "../../../css/mobile-intro/mobile-intro.css";
import {
    postDcSelUserVeh,
    postDcUpdUserVeh,
    postDcDailyCheckItemCdList,
    postDcSelDailyCheckDetail,
    postDcInsDailyCheck
} from "../../../api/dailyCheck";
import { toast } from "wc-toast";
import Loading from "../../../componant/loading/Loading";




export default function DailyCheck() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const paramDate = searchParams.get("date");


    const [driverName, setDriverName] = useState("");
    const [carNumber, setCarNumber] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [checkDate, setCheckDate] = useState(paramDate || dayjs().format("YYYY-MM-DD"));
    const [remarks, setRemarks] = useState("");
    const [isReadOnly, setIsReadOnly] = useState(false);

    const [dbInspectionItems, setDbInspectionItems] = useState([]);

    const [answers, setAnswers] = useState({});

    const [loading, setLoading] = useState(true);
    const [isVehSaving, setIsVehSaving] = useState(false);
    const [dataSaving, setDataSaving] = useState(false);

    const FLAG_TO_TEXT = { G: "양호", B: "불량", N: "미운행" };
    const TEXT_TO_FLAG = { "양호": "G", "불량": "B", "미운행": "N" };

    const isFirstRender = useRef(true);
    const lastValidDateRef = useRef(checkDate);

    const initMasterData = async () => {
        setLoading(true);
        try {
            await Promise.all([
                callPostDcSelUserVeh(),
                callPostDcDailyCheckItemCdList()
            ]);

            const targetDateObj = dayjs(checkDate);
            const todayObj = dayjs().startOf("day");

            if (targetDateObj.isAfter(todayObj)) {
                toast.error("올바르지 않은 날짜 접근입니다. 현재 날짜로 이동합니다.");
                const todayStr = dayjs().format("YYYY-MM-DD");
                setCheckDate(todayStr);
                await callPostDcSelDailyCheckDetail(todayStr);
            } else if (checkDate) {
                await callPostDcSelDailyCheckDetail(checkDate);
            }
        } catch (err) {
            console.error("초기 데이터 로드 실패", err);
        } finally {
            setLoading(false);
        }
    };

    const callPostDcSelUserVeh = async () => {
        try {
            const response = await postDcSelUserVeh({});
            if (response?.code === 1000) {
                setCarNumber(response?.veh_number || "");
                setDriverName(response?.user_nm || "");
                setBusinessName(response?.tb_nm || "");
                if (response?.veh_number) {
                    setIsReadOnly(true);
                }
            }
        } catch (err) {
            console.error("차량번호 로드 실패", err);
        }
    };


    const callPostDcDailyCheckItemCdList = async () => {
        try {
            const response = await postDcDailyCheckItemCdList({});
            if (response?.code === 1000) {
                setDbInspectionItems(response?.resultList || []);
            }
        } catch (err) {
            console.error("점검 항목 리스트 로드 실패", err);
        }
    };


    const callPostDcSelDailyCheckDetail = async (targetDate) => {
        try {
            const response = await postDcSelDailyCheckDetail({ check_date: targetDate });
            if (response?.code === 1000 && response?.result) {
                const data = response.result;
                setRemarks(data.check_msg || "");
                const savedAnswers = {};
                if (data.itemList && data.itemList.length > 0) {
                    data.itemList.forEach(item => {
                        savedAnswers[item.item_cd] = item.check_flag;
                    });
                    setAnswers(savedAnswers);
                }
                toast.success(`${targetDate} 점검 내역을 불러왔습니다.`);
            } else {

                setAnswers({});
                setRemarks("");
            }
        } catch (err) {
            console.error("상세 내역 로드 오류", err);
        }
    };

    const callPostDcUpdUserVeh = async () => {
        const vehRegex = /^[가-힣]{2}[89]\d[아바사자]\d{4}$/;
        if (!vehRegex.test(carNumber)) {
            toast.error("차량번호 형식이 아닙니다.");
            return;
        }

        if (!businessName) {
            toast.error("사업자명을 입력해 주세요.");
            return;
        }

        setIsVehSaving(true);
        try {
            const response = await postDcUpdUserVeh({
                veh_number: carNumber,
                tb_nm: businessName
            });

            if (response?.code === 1000) {
                toast.success("차량 및 사업자 정보 저장에 성공하였습니다.");
                setIsReadOnly(true);
            } else {
                toast.error("정보 저장에 실패하였습니다.");
            }
        } catch (err) {
            console.error("차량/사업자 정보 저장 오류:", err);
            toast.error("정보 저장 중 오류가 발생했습니다.");
        } finally {
            setIsVehSaving(false);
        }
    };

    useEffect(() => {
        initMasterData();
    }, []);


    const changeCheckDate = async (targetDate) => {
        setLoading(true);
        try {
            await callPostDcSelDailyCheckDetail(targetDate);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!checkDate || dbInspectionItems.length === 0) return;

        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        const clickedDateObj = dayjs(checkDate);
        const todayObj = dayjs().startOf("day");

        if (clickedDateObj.isAfter(todayObj)) {
            toast.error("일상점검표는 현재일과 과거일만 작성 할 수 있습니다.");
            setCheckDate(lastValidDateRef.current);
            return;
        }

        lastValidDateRef.current = checkDate;

        changeCheckDate(checkDate);

    }, [checkDate, dbInspectionItems]);

    const handleVehBtnClick = () => {
        if (isReadOnly) setIsReadOnly(false);
        else callPostDcUpdUserVeh();
    };

    const handleSelectAnswer = (itemCd, textVal) => {
        setAnswers((prev) => ({
            ...prev,
            [itemCd]: TEXT_TO_FLAG[textVal],
        }));
    };

    const handleSaveAll = async () => {
        if (!carNumber) {
            toast.error("차량번호를 입력하거나 저장해 주세요.");
            return;
        }


        if (!businessName) {
            toast.error("사업자명을 입력하거나 저장해 주세요.");
            return;
        }


        const actualItems = dbInspectionItems.filter(item => item.check_yn === "Y");
        const unselected = actualItems.filter(item => !answers[item.cd_seq]);

        if (unselected.length > 0) {
            toast.error(`미선택 문항이 존재합니다. (${unselected[0].item_cd_nm})`);
            return;
        }

        setDataSaving(true);

        const formattedItemList = actualItems.map(item => ({
            item_cd: item.cd_seq,
            check_flag: answers[item.cd_seq]
        }));

        const payload = {
            veh_number: carNumber,
            tb_nm: businessName,
            check_date: checkDate,
            check_time: dayjs().format("HH:mm"),
            check_msg: remarks,
            itemList: formattedItemList
        };

        try {
            const response = await postDcInsDailyCheck(payload);
            if (response?.code === 1000) {
                toast.success(`${checkDate} 일상점검표가 성공적으로 저장되었습니다.`);
                // navigate("/inspection/calendar");
            } else {
                toast.error("일상점검표 저장에 실패했습니다.");
            }
        } catch (err) {
            toast.error("서버 통신 오류 발생");
        } finally {
            setDataSaving(false);
        }
    };


    const categoryRows = dbInspectionItems.filter(item => item.check_yn === "N");
    const getFilteredItems = (categoryCdVal) => {
        return dbInspectionItems.filter(
            item => item.check_yn === "Y" && item.cd_val.startsWith(`${categoryCdVal}-`)
        );
    };



    if (loading) return <Loading />;

    return (
        <div
            className="mobile-intro-wrapper"
            style={{
                background: "#F8F9FA",
                maxWidth: "500px",
                margin: "0 auto",
                width: "100%",
                padding: "65px 15px 0px 15px",
                overflowY: "auto",
                WebkitOverflowScrolling: "touch"
            }}
        >


            <div className="d-flex align-items-center mb-3">
                <div className="w-100 bg-white rounded-3 p-3 d-flex align-items-center shadow-sm">
                    <div style={{ background: "#EBF3FF", width: "36px", height: "36px", borderRadius: "20%", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px" }}>
                        <img alt="" width="25" height="25" src={process.env.PUBLIC_URL + "/img/icon_application_off.png"} />
                    </div>
                    <h4 className="m-0 fs-5 fw-bold" style={{ color: "#212529" }}>운수종사자 일상점검표</h4>
                </div>
            </div>


            <div className="bg-white rounded-3 p-3 mb-4 shadow-sm">
                <div className="d-flex gap-2 mb-2 align-items-center">
                    <span className="badge d-inline-flex align-items-center justify-content-center rounded-2 flex-shrink-0" style={{ background: "#7CA3FF", color: "#fff", width: "80px", height: "36px", fontSize: "16px" }}>운전자명</span>
                    <input type="text" className="text-center fw-bold w-100 border text-dark" value={driverName} readOnly style={{ borderRadius: "8px", border: "1px solid #C8CED3", height: "36px", fontSize: "15px", fontWeight: "bold", background: "#DDE2E5", color: "#2B303A", cursor: "default", boxShadow: "inset 0 1px 3px rgba(0,0,0,0.12)", outline: "none" }} />
                </div>

                <div className="d-flex gap-2 align-items-stretch mt-3 w-100">
                    <div className="d-flex flex-column gap-2 flex-grow-1">
                        <div className="d-flex gap-2 align-items-center">
                            <span className="badge d-inline-flex align-items-center justify-content-center rounded-2 flex-shrink-0" style={{ background: "#7CA3FF", color: "#fff", width: "80px", height: "36px", fontSize: "15px" }}>차량번호</span>
                            <input
                                type="text"
                                className={isReadOnly ? "text-center fw-bold w-100 border text-dark" : "form-control text-center fw-bold w-100"}
                                value={carNumber}
                                onChange={(e) => setCarNumber(e.target.value)}
                                readOnly={isReadOnly}
                                maxLength={9}
                                placeholder="예: 서울86아1234"
                                style={{
                                    borderRadius: "8px",
                                    border: "1px solid #C8CED3",
                                    height: "36px",
                                    fontSize: "14px",
                                    background: isReadOnly ? "#DDE2E5" : "#FFFFFF",
                                    color: isReadOnly ? "#2B303A" : "#212529",
                                    cursor: isReadOnly ? "default" : "text",
                                    boxShadow: isReadOnly ? "inset 0 1px 3px rgba(0,0,0,0.12)" : "none",
                                    outline: "none"
                                }}
                            />
                        </div>

                        <div className="d-flex gap-2 align-items-center">
                            <span className="badge d-inline-flex align-items-center justify-content-center rounded-2 flex-shrink-0" style={{ background: "#7CA3FF", color: "#fff", width: "80px", height: "36px", fontSize: "15px" }}>사업자명</span>
                            <input
                                type="text"
                                className={isReadOnly ? "text-center fw-bold w-100 border text-dark" : "form-control text-center fw-bold w-100"}
                                value={businessName}
                                onChange={(e) => setBusinessName(e.target.value)}
                                readOnly={isReadOnly}
                                maxLength={20}
                                placeholder="사업자명 입력"
                                style={{
                                    borderRadius: "8px",
                                    border: "1px solid #C8CED3",
                                    height: "36px",
                                    fontSize: "14px",
                                    background: isReadOnly ? "#DDE2E5" : "#FFFFFF",
                                    color: isReadOnly ? "#2B303A" : "#212529",
                                    cursor: isReadOnly ? "default" : "text",
                                    boxShadow: isReadOnly ? "inset 0 1px 3px rgba(0,0,0,0.12)" : "none",
                                    outline: "none"
                                }}
                            />
                        </div>
                    </div>

                    <button
                        type="button"
                        onClick={handleVehBtnClick}
                        disabled={isVehSaving}
                        className="btn p-0 fw-bold text-white text-nowrap flex-shrink-0 d-flex align-items-center justify-content-center"
                        style={{
                            background: isReadOnly && !isVehSaving ? '#1B7F4B' : '#4A70D6',
                            borderRadius: "8px",
                            width: "55px",
                            height: "80px",
                            opacity: isVehSaving ? 0.8 : 1,
                            transition: "all 0.2s ease"
                        }}
                    >
                        {isVehSaving ? (
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                role="status"
                                aria-label="loading"
                            >
                                <circle
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="3"
                                    opacity="0.25"
                                />
                                <path
                                    d="M12 2a10 10 0 0 1 10 10"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="3"
                                >
                                    <animateTransform
                                        attributeName="transform"
                                        type="rotate"
                                        from="0 12 12"
                                        to="360 12 12"
                                        dur="0.8s"
                                        repeatCount="indefinite"
                                    />
                                </path>
                            </svg>
                        ) : (
                            isReadOnly ? "수정" : "저장"
                        )}
                    </button>
                </div>
            </div>

            <div className="bg-light rounded-3 p-3 mb-3 text-center border mt-3">
                <h3 className="m-0 fs-5 fw-bold" style={{ color: "#212529" }}>화물자동차 점검등록</h3>
            </div>


            <div className="d-flex gap-2 align-items-center mb-5 mt-1">
                <span className="badge d-inline-flex align-items-center justify-content-center flex-shrink-0 py-2 px-3" style={{ background: "#EAA135", color: "#fff", borderRadius: "6px", fontSize: "16px", width: "90px", height: "44px" }}>점검일시</span>
                <input type="date" className="form-control text-center fs-5" value={checkDate} onChange={(e) => setCheckDate(e.target.value)} style={{ borderRadius: "6px", height: "44px" }} />
            </div>


            <div className="d-flex flex-column gap-3">
                {categoryRows.map((category) => {
                    const filteredItems = getFilteredItems(category.cd_val);
                    if (filteredItems.length === 0) return null;

                    return (
                        <div key={category.cd_seq} className="mb-4 bg-white rounded-4 p-3 shadow-sm border" style={{ borderColor: "#f9f8f4" }}>

                            <div className="d-flex justify-content-between align-items-center px-1 mb-2">
                                <span className="fw-bold" style={{ color: "#333", fontSize: "22px" }}>
                                    {category.cd_val}. {category.item_cd_nm}
                                </span>
                                <span className="text-muted bg-white px-2 py-1 rounded-pill border" style={{ fontSize: "14px" }}>
                                    {filteredItems.length}개 항목
                                </span>
                            </div>
                            <p className="text-muted px-1 mb-3" style={{ fontSize: "16px" }}>{category.description}</p>


                            <div className="d-flex flex-column gap-3 mb-4">
                                {filteredItems.map((item) => {
                                    const currentSelection = answers[item.cd_seq];
                                    const currentText = FLAG_TO_TEXT[currentSelection] || "";

                                    return (
                                        <div key={item.cd_seq} className="bg-white rounded-3 p-3 shadow-sm border" style={{ borderColor: "#fbfbf9" }}>

                                            <span className="fw-bold fs-12" style={{ color: "#1B7F4B" }}>{item.cd_val}</span>


                                            <h4 className="fw-bold mt-1 mb-3" style={{ color: "#212529", fontSize: "15px", fontWeight: "bold" }}>
                                                {item.description}
                                            </h4>


                                            <div className="d-flex gap-2">
                                                {["양호", "불량", "미운행"].map((text) => (
                                                    <button
                                                        key={text}
                                                        type="button"
                                                        onClick={() => handleSelectAnswer(item.cd_seq, text)}
                                                        className="btn w-100 py-2 border"
                                                        style={{
                                                            borderRadius: "8px",
                                                            background: currentText === text ? "#EAA135" : "#FFF",
                                                            color: currentText === text ? "#FFF" : "#666",
                                                            borderColor: currentText === text ? "#EAA135" : "#DEE2E6",
                                                            fontWeight: currentText === text ? "700" : "400"
                                                        }}
                                                    >
                                                        {text}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="rounded-3 p-3 mb-4 text-center shadow-sm" style={{ background: "#FFC107" }}>
                <p className="fw-bold mb-3" style={{ color: "#212529", fontSize: "15px", lineHeight: "1.4" }}>
                    이 버튼을 누르면 모든 항목이<br />자동으로 선택 상태로 변경됩니다.
                </p>

                <div className="d-flex gap-2 w-100">

                    <button
                        type="button"
                        onClick={() => {
                            const allPassed = {};
                            dbInspectionItems.filter(item => item.check_yn === "Y").forEach(item => {
                                allPassed[item.cd_seq] = "G"; 
                            });
                            setAnswers(allPassed);
                        }}
                        className="btn text-white fw-bold border-0 w-50 py-2 fs-16 d-flex align-items-center justify-content-center"
                        style={{ background: "#4A70D6", borderRadius: "10px", height: "48px" }}
                    >
                        모두 양호
                    </button>

                    <button
                        type="button"
                        onClick={() => {
                            const allNotRunning = {};
                            dbInspectionItems.filter(item => item.check_yn === "Y").forEach(item => {
                                allNotRunning[item.cd_seq] = "N";
                            });
                            setAnswers(allNotRunning);
                        }}
                        className="btn text-white fw-bold border-0 w-50 py-2 fs-16 d-flex align-items-center justify-content-center"
                        style={{ background: "#4A70D6", borderRadius: "10px", height: "48px" }} 
                    >
                        모두 미운행
                    </button>
                </div>
            </div>


            <div className="bg-white rounded-3 p-3 mb-4 shadow-sm border">
                <h5 className="fs-15 fw-bold mb-2" style={{ color: "#000" }}>불량상태 조치 기록</h5>
                <textarea className="form-control bg-light" rows="3" placeholder="예) 00일 창닦이기 교체" value={remarks} onChange={(e) => setRemarks(e.target.value)} style={{ borderRadius: "8px", border: "1px solid #DEE2E6", resize: "none", fontSize: "14px" }} />
            </div>


            <div className="d-flex gap-3 mb-5">
                <button
                    type="button"
                    onClick={() => { setAnswers({}); setRemarks(""); }}
                    className="btn text-white fw-bold border-0 w-100 d-flex align-items-center justify-content-center"
                    style={{
                        background: "#1B7F4B",
                        borderRadius: "10px",
                        height: "48px",
                        fontSize: "16px"
                    }}
                >
                    초기화
                </button>
                <button
                    type="button"
                    onClick={handleSaveAll}
                    className="btn text-white fw-bold border-0 w-100 d-flex align-items-center justify-content-center"
                    style={{
                        background: "#4A70D6",
                        borderRadius: "10px",
                        height: "48px",
                        fontSize: "16px"
                    }}
                >
                    {dataSaving ? (
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            role="status"
                            aria-label="loading"
                        >
                            <circle
                                cx="12"
                                cy="12"
                                r="10"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="3"
                                opacity="0.25"
                            />
                            <path
                                d="M12 2a10 10 0 0 1 10 10"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="3"
                            >
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 12 12"
                                    to="360 12 12"
                                    dur="0.8s"
                                    repeatCount="indefinite"
                                />
                            </path>
                        </svg>
                    ) : (
                        "저장"
                    )

                    }
                </button>


            </div>
        </div>
    );
}